import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UserDataService } from 'src/app/providers/userData/user-data.service';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import * as _ from 'lodash';
import { FormStatusMapping } from './form-status-mapping';
import { ExportPdfService } from 'src/app/providers/forms/report/export-pdf/export-pdf.service';
import { DatePipe } from '@angular/common';
import { Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { Constants } from 'src/app/util/constants';

@Component({
	selector: 'app-header',
	standalone: false,
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
	@Input() pageSpecificFormObject;
	@Input() profilePhoto;
	@Input() sharedWith;
	@Output() headerEmiiter: EventEmitter<any> = new EventEmitter<any>();
	@Input() userProfile;
	@Input() formTypeId;

	showSharedWithNames: boolean = false;
	showRejectionReason: boolean = false;
	showRecallWithNames: boolean = false;
	showSubmitForApprovalWithNames: boolean = false;
	showResentWithNames: boolean = false;
	showCoordinatorRemarks: boolean = false;
	loggedInUserName: any;

	sharedWithNames = [];
	pdfLoading = false;
	isFROMIQACDASHBOARD: boolean = false;

	// Bottom Sheet Properties
	isBottomSheetOpen: boolean = false;
	constructor(
		private datePipe: DatePipe,
		public userdataService: UserDataService,
		private exportPdfService: ExportPdfService,
		private platform: Platform,
		private file: File,
		private fileOpener: FileOpener,
		public router: Router
	) {}

	closeAlert() {
		this.showSharedWithNames = false;
	}

	closeAlert1() {
		this.showSubmitForApprovalWithNames = false;
	}

	ngOnInit() {
		this.userdataService.getCurrentActiveSection().then((section) => {
			if (section) {
				if (section === 'IQAC_DASHBORAD') {
					this.isFROMIQACDASHBOARD = true;
				} else {
					this.isFROMIQACDASHBOARD = false;
				}
			}
		});
		this.userdataService.getUserProfile().then((profile) => {
			if (profile) {
				this.loggedInUserName = profile.emailId;
				//  this.userProfile = profile;
			} else {
				window.dispatchEvent(new CustomEvent('user:force-logout'));
			}
		});
	}

	getStatusLabel() {
		return FormStatusMapping.getStatusLabel(this.pageSpecificFormObject.status);
	}

	getStatusClassName() {
		return FormStatusMapping.getStatusClassName(this.pageSpecificFormObject.status);
	}

	getStatusIcon() {
		const status = this.pageSpecificFormObject.status;
		const iconMap = {
			APPROVED: 'fas fa-check-circle',
			APPROVED_WITH_WebC: 'fas fa-check-circle',
			APPROVED_WITH_OFFICE_CO: 'fas fa-check-circle',
			APPROVED_WITH_WEB_AND_OFFICE: 'fas fa-check-circle',
			APPROVED_WITH_WebC_UPDATED: 'fas fa-check-circle',
			APPROVED_WITH_OFFICE_CO_UPDATED: 'fas fa-check-circle',
			APPROVED_WITH_WEB_AND_OFFICE_UPDATED: 'fas fa-check-circle',
			APPROVED_WITH_BOTH_OFFICE_UPDATED: 'fas fa-check-circle',
			APPROVED_WITH_BOTH_WebC_UPDATED: 'fas fa-check-circle',
			SUBMITTED_FOR_APPROVAL: 'fas fa-paper-plane',
			SHARED: 'fas fa-share-alt',
			RESENT: 'fas fa-undo',
			RECALLED: 'fas fa-arrow-rotate-left',
			REVERTED: 'fas fa-exclamation-triangle',
			CREATED: 'fas fa-edit',
			DRAFT: 'fas fa-file-alt',
			PENDING: 'fas fa-clock',
			IN_REVIEW: 'fas fa-search',
			REJECTED: 'fas fa-times-circle'
		};

		return iconMap[status] || 'fas fa-circle-info';
	}

	replicableToggleChnage() {
		this.headerEmiiter.emit(this.pageSpecificFormObject.replicable);
	}

	canShowReplicable() {
		return (
			(this.loggedInUserName == this.pageSpecificFormObject.createdBy || this.pageSpecificFormObject.id == null) &&
			this.pageSpecificFormObject.status != 'APPROVED'
		);
	}

	toggleShowSharedWithNames() {
		this.showSharedWithNames = !this.showSharedWithNames;
	}
	toggleShowRecallWithNames() {
		this.showRecallWithNames = !this.showRecallWithNames;
	}
	toggleShowResentWithNames() {
		this.showResentWithNames = !this.showResentWithNames;
	}
	toggleShowSubmitForApprovalWithNames() {
		this.showSubmitForApprovalWithNames = !this.showSubmitForApprovalWithNames;
	}
	toggleShowRejectionReason() {
		this.showRejectionReason = !this.showRejectionReason;
	}
	toggleShowCoordinatorRemarks() {
		this.showCoordinatorRemarks = !this.showCoordinatorRemarks;
	}
	getSharedWith(): string {
		if (!this.pageSpecificFormObject.sharedWith) return '';
		return this.pageSpecificFormObject.sharedWith.replace(/\bnull\b\s*/g, '').trim();
	}
	isCoordinatorApprovedStatus(): boolean {
		const status = this.pageSpecificFormObject.status;
		return [
			'APPROVED_WITH_WebC',
			'APPROVED_WITH_OFFICE_CO',
			'APPROVED_WITH_WEB_AND_OFFICE',
			'APPROVED_WITH_WebC_UPDATED',
			'APPROVED_WITH_OFFICE_CO_UPDATED',
			'APPROVED_WITH_WEB_AND_OFFICE_UPDATED',
			'APPROVED_WITH_BOTH_OFFICE_UPDATED',
			'APPROVED_WITH_BOTH_WebC_UPDATED'
		].includes(status);
	}

	profilePhotoAvailable() {
		return false; // this.profilePhoto !== undefined && this.profilePhoto !== null && !_.endsWith(this.profilePhoto, 'null');
	}
	canPrint() {
		return this.pageSpecificFormObject.id !== undefined;
	}
	exportPdf() {
		this.pdfLoading = true;
		let payload = {
			formId: this.pageSpecificFormObject.id,
			formTypeId: this.formTypeId
		};
		this.userdataService.getToken().then((token) => {
			if (token) {
				let now = this.datePipe.transform(new Date(), 'dd-MM-yyyy');
				let fileName =
					'Report_' +
					this.pageSpecificFormObject.id +
					'_' +
					this.pageSpecificFormObject.formType.routeLink +
					'_' +
					now +
					'.pdf';
				this.exportPdfService.exportPdf(payload, token).then(
					(response) => {
						this.pdfLoading = false;
						if (response) {
							if (this.platform.is('android') || this.platform.is('ios')) {
								return this.file
									.writeFile(this.file.externalRootDirectory + '/Download', fileName, new Blob([response]), {
										replace: true
									})
									.then(() => {
										this.userdataService.presentToast('Report Downloaded Successfully!', 'success');
										return this.fileOpener.open(
											this.file.externalRootDirectory + '/Download/' + fileName,
											'application/pdf'
										);
									})
									.catch((error) => {
										console.error(JSON.stringify(error));
										this.userdataService.presentToast('Report Download Failed!', 'danger');
									});
							} else {
								const url = window.URL.createObjectURL(new Blob([response]));
								const link = document.createElement('a');
								link.href = url;
								link.setAttribute('download', fileName);
								link.setAttribute('target', '_blank');
								document.body.appendChild(link);
								link.click();
								link.parentNode.removeChild(link);
							}
						} else {
							this.userdataService.presentToast('Something Went Wrong! Plese try again later.', 'danger');
						}
						return null;
					},
					(error) => {
						this.pdfLoading = false;
					}
				);
			}
		});
	}

	canUpdate(): boolean {
		if (this.pageSpecificFormObject.status != undefined) {
			return (
				this.pageSpecificFormObject.id &&
				this.isIQACSubsection() &&
				(this.pageSpecificFormObject.status == 'CREATED' ||
					(this.pageSpecificFormObject.status == 'REVERTED' &&
						this.loggedInUserName == this.pageSpecificFormObject.createdBy) ||
					(this.pageSpecificFormObject.status == 'RECALLED' &&
						this.loggedInUserName == this.pageSpecificFormObject.createdBy) ||
					(this.pageSpecificFormObject.status == 'RESENT' &&
						this.loggedInUserName == this.pageSpecificFormObject.createdBy) ||
					(this.pageSpecificFormObject.status == 'SHARED' &&
						this.loggedInUserName != this.pageSpecificFormObject.createdBy))
			);
		} else {
			return true;
		}
	}

	isIQACSubsection(): boolean {
		var result =
			!this.isFROMIQACDASHBOARD ||
			(this.pageSpecificFormObject.formTypeDTO !== undefined &&
				this.pageSpecificFormObject.formTypeDTO.fomSubSection !== undefined &&
				this.pageSpecificFormObject.formTypeDTO.fomSubSection.id !== undefined &&
				this.pageSpecificFormObject.formTypeDTO.fomSubSection.id === 31);
		return result;
	}

	canDownloadPDF(): boolean {
		if (this.pageSpecificFormObject.status != undefined) {
			return (
				this.pageSpecificFormObject.id &&
				(this.pageSpecificFormObject.status == 'APPROVED' ||
					this.pageSpecificFormObject.status == 'APPROVED_WITH_WebC' ||
					this.pageSpecificFormObject.status == 'APPROVED_WITH_OFFICE_CO' ||
					this.pageSpecificFormObject.status == 'APPROVED_WITH_WEB_AND_OFFICE' ||
					this.pageSpecificFormObject.status == 'APPROVED_WITH_WebC_UPDATED' ||
					this.pageSpecificFormObject.status == 'APPROVED_WITH_OFFICE_CO_UPDATED' ||
					this.pageSpecificFormObject.status == 'APPROVED_WITH_WEB_AND_OFFICE_UPDATED' ||
					this.pageSpecificFormObject.status == 'APPROVED_WITH_BOTH_OFFICE_UPDATED' ||
					this.pageSpecificFormObject.status == 'APPROVED_WITH_BOTH_WebC_UPDATED')
			);
		} else {
			return true;
		}
	}

	doRefresh(event) {
		if (this.pageSpecificFormObject.id && this.pageSpecificFormObject.formType.routeLink) {
			setTimeout(() => {
				this.router.navigate([
					'new-' + this.pageSpecificFormObject.formType.routeLink,
					{ formId: this.pageSpecificFormObject.id }
				]);
				event.target.complete();
			}, 2000);
		} else {
			event.target.complete();
		}
	}

	// Bottom Sheet Methods
	toggleBottomSheet() {
		this.isBottomSheetOpen = !this.isBottomSheetOpen;

		// Add body class for overlay styling when sheet is open
		if (this.isBottomSheetOpen) {
			document.body.classList.add('bottom-sheet-open');
		} else {
			document.body.classList.remove('bottom-sheet-open');
		}
	}

	closeBottomSheet() {
		this.isBottomSheetOpen = false;
		document.body.classList.remove('bottom-sheet-open');
	}

	openBottomSheet() {
		this.isBottomSheetOpen = true;
		document.body.classList.add('bottom-sheet-open');
	}

	isApproved(): boolean {
		return Constants.IS_APPROVED(this.pageSpecificFormObject);
	}
}
